<template>
  <section id="publications" class="section pubs">
    <div class="container">
      <div class="pubs__head">
        <div class="section-head" v-reveal>
          <span class="eyebrow">06 / Publications</span>
          <h2 class="section-title">
            <span class="en">Publications</span>
            発信していること
          </h2>
        </div>
        <p class="pubs__lead" v-reveal="80">
          私たちがふだんどのように AI を使って開発しているかは、社外の技術プラットフォームで継続的に公開しています。毎朝の AI ニュースを全自動で記事化する仕組み、開発の記録、Anthropic の公式オンラインコースを日本語で整理したノート。うまくいった話だけでなく、止まった原因や作り直した経緯も、そのまま書いています。サービス紹介よりも、実際の進め方が伝わるはずです。
        </p>
      </div>

      <p class="pubs__note" v-reveal="100">
        以下はいずれも、代表 桧山 聡（hijamac）の個人アカウントです。法人の公式アカウントではありません。
      </p>

      <ul class="pubs__list">
        <li v-for="(item, i) in links" :key="item.url" v-reveal="60 + i * 40">
          <a class="pub" :href="item.url" target="_blank" rel="noopener">
            <span class="pub__host">{{ item.host }}</span>
            <span class="pub__label">{{ item.label }}</span>
            <span v-if="item.note" class="pub__note">{{ item.note }}</span>
            <span class="pub__arrow" aria-hidden="true">
              <svg viewBox="0 0 16 16" width="16" height="16">
                <path d="M4 12L12 4M6 4h6v6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PublicationsSection',
  data() {
    return {
      links: [
        {
          label: '今朝のAIニュース（note マガジン）',
          url: 'https://note.com/hijamac/m/m696dcdc1b035',
          host: 'note.com',
          note: '毎朝、収集から公開まで自動で記事化しています。出典リンク付き',
        },
        {
          label: 'Anthropic Academy 全コース攻略（note 目次記事）',
          url: 'https://note.com/hijamac/n/nd1c4314b2ae2',
          host: 'note.com',
          note: 'Anthropic 公式のオンラインコースの内容を、AI で日本語に整理したノートです',
        },
        {
          label: 'X',
          url: 'https://x.com/hijamac',
          host: 'x.com',
          note: '',
        },
        {
          label: 'Threads',
          url: 'https://www.threads.com/@hijamac',
          host: 'threads.com',
          note: '',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.pubs {
  border-top: 1px solid var(--line);
}

.pubs__head {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: end;
}

.pubs__lead {
  max-width: 46ch;
  font-size: clamp(1rem, 1.3vw, 1.1rem);
  line-height: 1.9;
  color: var(--ink-soft);
}

.pubs__note {
  margin-top: clamp(36px, 5vw, 56px);
  padding-left: 18px;
  border-left: 2px solid var(--accent-line);
  font-size: 0.86rem;
  line-height: 1.8;
  color: var(--ink-soft);
}

.pubs__list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 28px;
}

.pub {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: clamp(24px, 2.6vw, 32px);
  padding-right: clamp(52px, 5vw, 64px);
  background: var(--paper-raised);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  transition: transform 0.4s var(--ease), box-shadow 0.4s var(--ease),
    border-color 0.4s var(--ease);
}

.pub:hover {
  transform: translateY(-4px);
  border-color: var(--accent-line);
  box-shadow: 0 40px 70px -50px rgba(83, 48, 27, 0.55);
}

.pub__host {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 10px;
}

.pub__label {
  font-family: var(--font-jp);
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.5;
  color: var(--ink);
}

.pub__note {
  margin-top: 10px;
  font-size: 0.88rem;
  line-height: 1.8;
  color: var(--ink-soft);
}

.pub__arrow {
  position: absolute;
  top: clamp(24px, 2.6vw, 32px);
  right: clamp(24px, 2.6vw, 32px);
  display: inline-flex;
  color: var(--faint);
  transition: transform 0.3s var(--ease), color 0.3s var(--ease);
}

.pub:hover .pub__arrow {
  color: var(--accent);
  transform: translate(2px, -2px);
}

@media (max-width: 760px) {
  .pubs__head {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .pubs__list {
    grid-template-columns: 1fr;
  }
}
</style>
